import { useRouter } from 'next/router'
import { CERTIFICATE_OF_COMPLETION_ADDRESS } from '../consts/certificate-of-completion'
import { useCourseData } from './use-course-data'
import { useGetCoursePageUrl } from './use-course-path-url'

export default function useCertificateOfCompletion(): {
  isOnCertificatePage: boolean
  isCertificateAvailable: boolean
  certificatePageUrl: string
  redirectToCertificate: () => Promise<boolean>
  getCertificateLink: () => string
} {
  const router = useRouter()
  const coursePath = useGetCoursePageUrl()
  const { courseData } = useCourseData()

  // TODO: regex without examples, kinda bad tbh, its not really obvious what this hook do, we should work on naming and maybe add some comments
  // eslint-disable-next-line no-useless-escape
  const regexp = new RegExp(`\/school\/course\/.*\/${CERTIFICATE_OF_COMPLETION_ADDRESS}`)
  const isOnCertificatePage = regexp.test(router.pathname)

  const isCertificateAvailable = !!(
    courseData?.issueCertificateUponCompletion && courseData.completed
  )

  const certificatePageUrl = `/school/course/${coursePath}/${CERTIFICATE_OF_COMPLETION_ADDRESS}`

  const redirectToCertificate = async (): Promise<boolean> => router.replace(certificatePageUrl)

  const getCertificateLink = (): string =>
    isCertificateAvailable ? `/api/membership/course/${coursePath}/certificate` : ''

  return {
    isOnCertificatePage,
    isCertificateAvailable,
    certificatePageUrl,
    redirectToCertificate,
    getCertificateLink,
  }
}
